import {
  BACKEND_KEYS,
  modeOfPaymentValues,
  smartCameraKey,
  sixMonthsFree,
  tsbSecurityOffersObject,
  ignoredKeysOfSelectedItems
} from '../../../utils/constant';
import { getInstallationFeeDiscount } from '../../businessLogic/secureBusines/offers';
import { getLocalizedStrings, getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const { secureBusinessStep } = BACKEND_KEYS;

export const getFieldPriceOrLabel = (
  fields,
  fieldValue,
  shouldReturnPrice = true
) => {
  for (let i = 0; i < fields.length; i += 1) {
    const field = fields[i];
    if (field.fields.formStepFields && field.fields.formStepFields.length) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.formStepFields,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (
      field.fields.easyPaymentFields &&
      field.fields.easyPaymentFields.length
    ) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.easyPaymentFields,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (
      field.fields.fiveYearEasyPaymentFields &&
      field.fields.fiveYearEasyPaymentFields.length
    ) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.fiveYearEasyPaymentFields,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (field.fields.options && field.fields.options.length) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.options,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (
      field.fields.name === fieldValue ||
      field.fields.value === fieldValue ||
      field.fields.backendKey === fieldValue
    ) {
      if (!shouldReturnPrice) {
        return field.fields.label;
      }
      if (
        field.fields.price ||
        field.fields.oneTimePrice ||
        field.fields.monthlyPayment ||
        field.fields.fiveYearEasyPayment
      ) {
        return {
          oneTime: field.fields.oneTimePrice || field.fields.price || 0,
          monthly: field.fields.monthlyPayment || 0,
          monthlyFiveYear: field.fields.fiveYearEasyPayment || 0
        };
      }
    }
  }
  return null;
};

export default (orderData, steps) => {
  const {
    quoteSummary: {
      secureBusinessPackages: { Monitor },
      secureBusinessOffers: {
        twentyOffWireline,
        zeroInstallation,
        hardwareCredit,
        threeMonthFree,
        tenOffMpp,
        twentyOffMpp,
        installationOff,
        installationOff199,
        tenOFFWireless,
        tenOFFWireline,
        tenOffWirelene,
        sixMonthFree,
        fivePercenDiscount,
        threeDollarOff,
        twentyDollarMonthlyDiscount,
        waivedInstallationFee
      }
    }
  } = getLocalizedStrings();
  const locale = getLocale();

  const {
    WLS: { _tenDollarOff }
  } = locale === 'en-US' ? EN : FR;

  const product = {
    selectedEquipments: [],
    includedEquipments: [],
    additionalEquipments: [],
    additionalEquipmentsEasyPayments: [],
    limitedTimeOffers: [],
    regularOffers: [],
    features: []
  };

  let oneTime = 0;
  let monthly = 0;
  let monthlyFiveYear = 0;
  let serviceFee = 0;
  let additionalEquipmentsTotal = 0;
  const {
    fields: { formStepFields }
  } = steps.find(s => s.fields.backendKey === secureBusinessStep);
  if (formStepFields && formStepFields.length) {
    const selectedPackage = orderData.telusSecureBusinessSecurityPackage;
    const selectedPackagePrice = getFieldPriceOrLabel(
      formStepFields,
      selectedPackage
    );
    const installationPrice = selectedPackagePrice.oneTime;

    oneTime += installationPrice;
    monthly += selectedPackagePrice.monthly;
    monthlyFiveYear += selectedPackagePrice.monthlyFiveYear;

    product.securityPackage = {
      value: selectedPackage,
      qty: 1,
      prices: {
        monthly: selectedPackagePrice.monthly,
        monthlyFiveYear: selectedPackagePrice.monthlyFiveYear
      }
    };
    if (product.securityPackage && product.securityPackage.value.toLowerCase() === "smartcamera") {
      product.securityPackage.value = "Smart Camera";
    }

    product.Installation = {
      value: "Installation Fee",
      qty: '',
      prices: {
        oneTime: installationPrice,
        monthly: '',
        monthlyFiveYear: ''
      }
    };
    const selectedtsbTerm = (orderData && orderData.secureBusinessTerm) || '';
    product.tsbTerm = {
      value: selectedtsbTerm,
      qty: '',
      prices: {
        monthly: '',
        oneTime: '',
        monthlyFiveYear: ''
      }
    };

    const ADDITIONAL_EQUIPMENT = 'AdditionalEquipment';
    const INCLUDED_EQUIPMENT = 'IncludedEquipment';
    const INCLUDED_EQUIPMENT_SELECTION = 'IncludedEquipmentSelection';

    const packageIEKey = `${selectedPackage &&
    selectedPackage.toLowerCase()}${INCLUDED_EQUIPMENT}`;
    const packageIESKey = `${selectedPackage &&
    selectedPackage.toLowerCase()}${INCLUDED_EQUIPMENT_SELECTION}`;
    const packageAEKey = `${selectedPackage &&
    selectedPackage.toLowerCase()}${ADDITIONAL_EQUIPMENT}`;
    const includedEquipments =
      orderData[packageIEKey] &&
      Object.keys(orderData[packageIEKey])
        .map(iEKey => {
          const value = getFieldPriceOrLabel(formStepFields, iEKey, false);
          return {
            value,
            qty: orderData[packageIEKey][iEKey],
            prices: {
              monthly: 0,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          };
        })
        .filter(item => item.qty > 0);

    const calculateTempSensors = aEKey => {
      const equipmentSelections = orderData[aEKey];
      const sensorKeys = [
        'temperatureSensor',
        'easyTemperatureSensor',
        'easyFiveYearTemperatureSensor'
      ];

      const totalSensors = sensorKeys.reduce((total, sensor) => {
        if (equipmentSelections[sensor]) {
          return total + parseInt(equipmentSelections[sensor], 10);
        }
        return total;
      }, 0);

      return totalSensors;
    };

    const excludedEquipments = ["businessActivityAnalytics"];
    const additionalEquipments =
      orderData[packageAEKey] &&
      Object.keys(orderData[packageAEKey])
        .filter(aEKey => !excludedEquipments.includes(aEKey))
        .map(aEKey => {
          const value = getFieldPriceOrLabel(formStepFields, aEKey, false);
          let prices = getFieldPriceOrLabel(formStepFields, aEKey, true);
          const qty = parseInt(orderData[packageAEKey][aEKey], 10);
          const monthlyString = aEKey.startsWith('easyFiveYear')
            ? modeOfPaymentValues.MONTHLY_FIVE_YEAR
            : modeOfPaymentValues.MONTH_TO_MONTH;
          const modeOfPaymentCondition = aEKey.startsWith('easy')
            ? monthlyString
            : modeOfPaymentValues.ONE_TIME;
          if (prices) {
            additionalEquipmentsTotal +=
              (prices.monthly && prices.monthly * qty) ||
              (prices.oneTime && prices.oneTime * qty) ||
              (prices.monthlyFiveYear && prices.monthlyFiveYear * qty);
            monthly += prices.monthly * qty;
            oneTime += prices.oneTime * qty;
            monthlyFiveYear += prices.monthlyFiveYear * qty;
            if (modeOfPaymentCondition === modeOfPaymentValues.MONTH_TO_MONTH) {
              prices.monthly *= qty;
            }
            if (modeOfPaymentCondition === modeOfPaymentValues.ONE_TIME) {
              prices.oneTime *= qty;
            }
            if (
              modeOfPaymentCondition === modeOfPaymentValues.MONTHLY_FIVE_YEAR
            ) {
              prices.monthlyFiveYear *= qty;
            }
          }
          // SOF-1773
          // Code here to calculate monthly service fee
          const totalSensorsCount = calculateTempSensors(packageAEKey);
          if (totalSensorsCount > 0 && totalSensorsCount <= 5) {
            serviceFee = 5;
          } else if (totalSensorsCount > 5 && totalSensorsCount <= 10) {
            serviceFee = 10;
          }
          calculateTempSensors(packageAEKey);
          prices = prices || {
            monthly: 0,
            oneTime: 0,
            monthlyFiveYear: 0
          };
          return {
            value,
            qty,
            prices,
            modeOfPayment: modeOfPaymentCondition,
            tempServiceFee: serviceFee
          };
        })
        .filter(item => item.qty > 0);

    const monthlyRecurringEquipment =
      orderData[packageAEKey] &&
      Object.keys(orderData[packageAEKey])
        .filter(aEKey => excludedEquipments.includes(aEKey))
        .map(aEKey => {

          const value = getFieldPriceOrLabel(formStepFields, aEKey, false);
          let prices = getFieldPriceOrLabel(formStepFields, aEKey, true);
          const qty = parseInt(orderData[packageAEKey][aEKey], 10);

          const modeOfPaymentCondition = aEKey.startsWith('easy')
            ? aEKey.startsWith('easyFiveYear')
              ? modeOfPaymentValues.MONTHLY_FIVE_YEAR
              : modeOfPaymentValues.MONTH_TO_MONTH
            : modeOfPaymentValues.ONE_TIME;

          if (prices) {
            additionalEquipmentsTotal +=
              (prices.monthly && prices.monthly * qty) ||
              (prices.oneTime && prices.oneTime * qty) ||
              (prices.monthlyFiveYear && prices.monthlyFiveYear * qty);
            monthly += prices.monthly * qty;
            oneTime += prices.oneTime * qty;
            monthlyFiveYear += prices.monthlyFiveYear * qty;

            if (modeOfPaymentCondition === modeOfPaymentValues.MONTH_TO_MONTH) {
              prices.monthly *= qty;
            }
            if (modeOfPaymentCondition === modeOfPaymentValues.ONE_TIME) {
              prices.oneTime *= qty;
            }
            if (modeOfPaymentCondition === modeOfPaymentValues.MONTHLY_FIVE_YEAR) {
              prices.monthlyFiveYear *= qty;
            }
          }

          prices = prices || {
            monthly: 0,
            oneTime: 0,
            monthlyFiveYear: 0
          };

          return {
            value,
            qty,
            prices,
            modeOfPayment: modeOfPaymentCondition
          };
        })
        .filter(item => item.qty > 0);

    if (includedEquipments && includedEquipments.length)
      product.includedEquipments = includedEquipments;
    if (additionalEquipments && additionalEquipments.length)
      product.additionalEquipments = additionalEquipments;
    if (monthlyRecurringEquipment && monthlyRecurringEquipment.length)
      product.monthlyRecurringEquipment = monthlyRecurringEquipment;

    if (selectedPackage !== Monitor) {
      const selectedIncludedEquipments =
        orderData[packageIESKey] &&
        Object.keys(orderData[packageIESKey])
          .map(siEKey => {
            const value = getFieldPriceOrLabel(formStepFields, siEKey, false);
            let prices = getFieldPriceOrLabel(formStepFields, siEKey, true);
            const qty = parseInt(orderData[packageIESKey][siEKey], 10);
            const monthlyString = siEKey.startsWith('easyFiveYear')
              ? modeOfPaymentValues.MONTHLY_FIVE_YEAR
              : modeOfPaymentValues.MONTH_TO_MONTH;
            const modeOfPaymentCondition = siEKey.startsWith('easy')
              ? monthlyString
              : modeOfPaymentValues.ONE_TIME;
            if (prices) {
              additionalEquipmentsTotal +=
                (prices.monthly && prices.monthly * qty) ||
                (prices.oneTime && prices.oneTime * qty) ||
                (prices.monthlyFiveYear && prices.monthlyFiveYear * qty);
              monthly += prices.monthly * qty;
              oneTime += prices.oneTime * qty;
              monthlyFiveYear += prices.monthlyFiveYear * qty;
              if (
                modeOfPaymentCondition === modeOfPaymentValues.MONTH_TO_MONTH
              ) {
                prices.monthly *= qty;
              }
              if (modeOfPaymentCondition === modeOfPaymentValues.ONE_TIME) {
                prices.oneTime *= qty;
              }
              if (
                modeOfPaymentCondition === modeOfPaymentValues.MONTHLY_FIVE_YEAR
              ) {
                prices.monthlyFiveYear *= qty;
              }
            }
            prices = prices || {
              monthly: 0,
              oneTime: 0,
              monthlyFiveYear: 0
            };
            return {
              value,
              qty,
              prices,
              modeOfPayment: modeOfPaymentCondition
            };
          })
          .filter(item => item.qty > 0);
      if (selectedIncludedEquipments && selectedIncludedEquipments.length) {
        product.selectedEquipments = selectedIncludedEquipments;
      }
      if (orderData.securityPackageFeature) {
        monthly +=
          getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            true
          ) &&
          getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            true
          ).monthly;
        product.features.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            false
          ),
          qty: 1,
          prices: getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            true
          )
        });
      }
    }

    // update smart camera offers
    if (selectedPackage === smartCameraKey) {
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(tenOFFWireline)) {
          monthly -= 10;
          product.regularOffers.push({
            value: tenOFFWireline,
            qty: 1,
            prices: {
              monthly: -10,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(tenOFFWireless)) {
          monthly -= 10;
          product.regularOffers.push({
            value: tenOFFWireless,
            qty: 1,
            prices: {
              monthly: -10,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(installationOff)) {
          oneTime -= 100;
          product.regularOffers.push({
            value: installationOff,
            qty: 1,
            prices: {
              monthly: 0,
              oneTime: -100,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(zeroInstallation)) {
          oneTime -= 199;
          product.regularOffers.push({
            value: zeroInstallation,
            qty: 1,
            prices: {
              monthly: 0,
              oneTime: -100,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(threeDollarOff)) {
          monthly -= 3;
          product.regularOffers.push({
            value: threeDollarOff,
            qty: 1,
            prices: {
              monthly: -3,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          });
        }
      }
    }

    const getNumberOfAdditionalEquipments = (arr) => (
      arr.filter((i) => !ignoredKeysOfSelectedItems.includes(i.value))
        .reduce((acc, i) => {
          const amount = i.qty ? +i.qty : 0;
          return acc + amount;
        }, 0));

    const addWaivedInstallationFee = (offers) => {
      const idx = offers.findIndex(i => i === waivedInstallationFee);
      if (idx === -1) return;

      const numberOfAdditionalEquipments = getNumberOfAdditionalEquipments(product.additionalEquipments);
      const oneTimePrice = getInstallationFeeDiscount(numberOfAdditionalEquipments);
      oneTime -= oneTimePrice;
      product.regularOffers.push({
        value: `$${oneTimePrice} ${waivedInstallationFee}`,
        qty: 1,
        prices: {
          monthly: 0,
          oneTime: -1 * oneTimePrice,
          monthlyFiveYear: 0
        }
      });
    };

    const { secureBusinessOffers } = orderData;
    if (secureBusinessOffers) {
      const isThreeOrSixMonthFreeIncluded =
        secureBusinessOffers.includes(threeMonthFree) ||
        secureBusinessOffers.includes(sixMonthsFree) ||
        secureBusinessOffers.includes(tsbSecurityOffersObject.sixMonthsFreeEn);
      const twentyDollarOffString =
        tsbSecurityOffersObject.twentyDollarOffEn ||
        tsbSecurityOffersObject.twentyDollarOffFr;

      if (secureBusinessOffers.includes(tenOffWirelene)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 10;
        product.regularOffers.push({
          value: tenOffWirelene,
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(fivePercenDiscount)) {
        monthly -= fivePercenDiscount ? 5 : 0;
        product.regularOffers.push({
          value: fivePercenDiscount,
          qty: 1,
          prices: {
            monthly: -5,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(twentyDollarOffString)) {
        monthly -= 20;
        product.regularOffers.push({
          value: tsbSecurityOffersObject.twentyDollarOffEn,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(_tenDollarOff)) {
        monthly -= 10;
        product.regularOffers.push({
          value: _tenDollarOff,
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(twentyOffWireline)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 20;
        product.regularOffers.push({
          value: twentyOffWireline,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(zeroInstallation)) {
        oneTime -= selectedPackagePrice.oneTime;
        product.regularOffers.push({
          value: zeroInstallation,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -selectedPackagePrice.oneTime
          }
        });
      }
      if (secureBusinessOffers.includes(threeMonthFree)) {
        monthly -= selectedPackagePrice.monthly;
        product.regularOffers.push({
          value: threeMonthFree,
          qty: 1,
          prices: {
            monthly: -selectedPackagePrice.monthly,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(sixMonthsFree)) {
        monthly -= selectedPackagePrice.monthly;
        product.regularOffers.push({
          value: sixMonthFree,
          qty: 1,
          prices: {
            monthly: -selectedPackagePrice.monthly,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (
        secureBusinessOffers.includes(tsbSecurityOffersObject.sixMonthsFreeEn)
      ) {
        monthly -= selectedPackagePrice.monthly;
        product.regularOffers.push({
          value: tsbSecurityOffersObject.sixMonthsFreeEn || sixMonthFree,
          qty: 1,
          prices: {
            monthly: -selectedPackagePrice.monthly,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(tenOffMpp)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 10;
        product.regularOffers.push({
          value: tenOffMpp,
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(twentyOffMpp)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 20;
        product.regularOffers.push({
          value: twentyOffMpp,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (secureBusinessOffers.includes(hardwareCredit)) {
        const subtractedAmount =
          additionalEquipmentsTotal > 200 ? 200 : additionalEquipmentsTotal;
        oneTime -= subtractedAmount;
        product.regularOffers.push({
          value: hardwareCredit,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -subtractedAmount
          }
        });
      }
      if (secureBusinessOffers.includes(installationOff)) {
        oneTime -= 100;
        product.regularOffers.push({
          value: installationOff,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -100
          }
        });
      }
      if (secureBusinessOffers.includes(installationOff199)) {
        oneTime -= 199;
        product.regularOffers.push({
          value: installationOff199,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -199
          }
        });
      }
      if (secureBusinessOffers.includes(twentyDollarMonthlyDiscount)) {
        monthly -= 20;
        product.regularOffers.push({
          value: twentyDollarMonthlyDiscount,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }

      addWaivedInstallationFee(secureBusinessOffers);
    }

    const { smartCameraOffers } = orderData;
    if (smartCameraOffers) {
      addWaivedInstallationFee(smartCameraOffers);
    }
  }
  monthly += serviceFee;

  const totalMonthly = (monthly > 0 && Math.abs(monthly.toFixed(2))) || 0;
  const totalMonthlyFiveYear =
    (monthlyFiveYear > 0 && Math.abs(monthlyFiveYear.toFixed(2))) || 0;
  const totalOneTime = (oneTime > 0 && Math.abs(oneTime.toFixed(2))) || 0;
  const temperatureServiceFee =
    (serviceFee > 0 && Math.abs(serviceFee.toFixed(2))) || 0;

  return {
    ...product,
    totalMonthly,
    totalMonthlyFiveYear,
    totalOneTime,
    temperatureServiceFee
  };
};
